import { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { easeInOutQuad } from 'easing-utils';

class MenuTransitionContext extends PureComponent {
  nextID = 0;
  elements = [];
  startTime: null;
  startValue: null;
  rafID = null;
  progress = 0;

  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
    open: PropTypes.bool.isRequired,
  };

  static childContextTypes = {
    registerMenuTransitionElement: PropTypes.func,
    unregisterMenuTransitionElement: PropTypes.func,
  };

  getChildContext = () => {
    return {
      registerMenuTransitionElement: this.registerElement,
      unregisterMenuTransitionElement: this.unregisterElement,
    };
  };

  constructor(props) {
    super(props);

    this.loop = this.loop.bind(this);
  }

  registerElement = updateProgress => {
    const id = this.nextID++;
    const element = {
      id,
      updateProgress,
    };

    this.elements = [...this.elements, element];
    return id;
  };

  unregisterElement = elementID => {
    const updatedElements = this.elements.filter(el => el.id !== elementID);
    this.elements = updatedElements;
  };

  componentDidUpdate(nextProps) {
    if (nextProps.open !== this.props.open) {
      this.startTime = Date.now();
      this.startValue = this.progress;
      this.rafID = requestAnimationFrame(this.loop);
    }
  }

  loop() {
    const { open } = this.props;
    const target = open ? 1 : 0;

    if (target !== this.progress) {
      this.rafID = requestAnimationFrame(this.loop);

      const duration = 500;
      const deltaTime = Date.now() - this.startTime;
      const nextProgress = Math.min(deltaTime / duration, 1);
      const factor = easeInOutQuad(nextProgress);

      const val = this.startValue + (target - this.startValue) * factor;
      this.progress = val;
      this.elements.forEach(element => {
        element.updateProgress(val);
      });
    } else {
      this.rafID = null;
    }
  }

  render() {
    return this.props.children;
  }
}

const mapStateToProps = state => {
  const { navigation: { open } } = state;
  return {
    open,
  };
};

export default connect(mapStateToProps, null)(MenuTransitionContext);



// WEBPACK FOOTER //
// ./src/modules/navigation/components/MenuTransitionContext.js